import React, { useState } from "react";
import { Menu, X, Bird } from "lucide-react";
import { siteData } from "../mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { brand, nav } = siteData;

  return (
    <header className="absolute top-0 inset-x-0 z-30">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <a href="#" className="flex items-center gap-2 text-white">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 border border-white/20">
            <Bird className="h-5 w-5 text-[#cfe7f8]" />
          </span>
          <span className="ht-display text-lg tracking-tight">{brand.shortName}</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-white/80 hover:text-white text-sm ht-body transition-colors"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#join"
            className="ht-btn inline-flex items-center justify-center rounded-full bg-[#cfe7f8] text-[#2c3e50] px-5 py-2 text-sm font-semibold"
          >
            Join Free
          </a>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#3d4e62]/95 backdrop-blur">
          <div className="px-6 py-4 flex flex-col gap-3">
            {nav.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-white/85 hover:text-white text-sm py-1"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#join"
              onClick={() => setOpen(false)}
              className="mt-2 ht-btn inline-flex items-center justify-center rounded-full bg-[#cfe7f8] text-[#2c3e50] px-5 py-2 text-sm font-semibold"
            >
              Join Free
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
